export default "__VITE_ASSET__CyOvzmkx__"